import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.5_@playwright+test@1.58.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.5_@playwright+test@1.58.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BuildStampLogger"] */ "/vercel/path0/src/components/system/BuildStampLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientErrorReporter"] */ "/vercel/path0/src/components/system/ClientErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandlers"] */ "/vercel/path0/src/components/system/GlobalErrorHandlers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/components/theme/ThemeProvider.tsx");
